import SucursalBeneficio from "./SucursalBeneficio";

export default SucursalBeneficio;
